import { Injectable } from "@angular/core";
@Injectable()
export class SinglePropertyPageModel {
  PropertyId: number;
  Title: string;
  Description: string;
  Purpose: string;
  Type: string;
  Price: string;
  PriceInWords: string;
  BedRooms: string;
  BathRooms: string;
  Area: number;
  AreaUnit: string;
  City: string;
  Location: string;
  OtherFeatures?: any;
  Images?: any;
  ContactFullName: string;
  ContactEmailAddress: string;
  ContactPhoneNumber: string;
  ImageUrl: string;
}
